<template>
  <div class="accordion-info">
    <div v-for="(item, index) in items"
         :key="index"
         :class="{'_open': index === openIndex}"
         class="accordion-info__item">
      <div @click.prevent="onToggle(index)"
           class="accordion-info__head">
        <h4 class="accordion-info__title">
          {{ item[nameKey] }}
        </h4>
        <button class="accordion-info__btn">
          <BaseSvg name="ico-arrow-light"/>
        </button>
      </div>
      <CollapseTransition>
        <div v-if="index === openIndex">
          <div
               class="accordion-info__content">
            <div v-html="item[contentKey]"
                 class="text"></div>
          </div>
        </div>
      </CollapseTransition>
    </div>
  </div>
</template>

<script>
  import {CollapseTransition} from 'vue2-transitions'

  export default {
    name: 'AccordionInfo',
    components: {
      CollapseTransition
    },
    props: {
      items: Array,
      nameKey: {
        type: String,
        default: 'name'
      },
      contentKey: {
        type: String,
        default: 'content'
      }
    },
    data() {
      return {
        openIndex: null
      }
    },
    methods: {
      onToggle(index) {
        if (index === this.openIndex) {
          this.openIndex = null
        } else {
          this.openIndex = index
        }
      }
    }
  }
</script>

<style lang="less">

</style>